/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IFooterCategoryConfig, IFooterCategoryProps } from './footer-category.props.autogenerated';

export interface IFooterCategoryViewProps extends IFooterCategoryProps<IFooterCategoryConfig> {
    categories: React.ReactNode[];
    FooterList: IModuleProps;
    FooterListItem: INodeProps;
}

/**
 *
 * FooterCategory component.
 * @extends {React.PureComponent<IFooterCategoryProps<IFooterCategoryConfig>>}
 */
class FooterCategory extends React.PureComponent<IFooterCategoryProps<IFooterCategoryConfig>> {
    public render(): JSX.Element | null {
        if (!this.props.slots || !this.props.slots.content || this.props.slots.content.length === 0) {
            this.props.context.telemetry.error('footer slots content is empty, module wont render');
            return null;
        }
        const viewprops = {
            ...this.props,
            categories: this.props.slots.content,
            FooterList: {
                moduleProps: this.props,
                className: classnames('ms-footer__list', this.props.config.className),
                tag: 'ul'
            },
            FooterListItem: {
                className: classnames('ms-footer__list-item', this.props.config.className),
                tag: 'li'
            }
        };

        return this.props.renderView(viewprops) as React.ReactElement;
    }
}

export default FooterCategory;
